if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}


const initLittleZeEditionSelectors = (scope = document) => {
  const roots = [];
  if (scope && typeof scope.matches === 'function' && scope.matches('[data-lz-edition-selector]')) {
    roots.push(scope);
  }
  if (scope && typeof scope.querySelectorAll === 'function') {
    roots.push(...scope.querySelectorAll('[data-lz-edition-selector]'));
  }

  roots.forEach((root) => {
    if (!root || root.dataset.bound === 'true') return;

    const sectionId = root.dataset.sectionId || '';
    const sectionRoot =
      root.closest('.shopify-section') || root.closest('section') || root.parentElement || document;
    const form =
      (sectionId && document.getElementById(`product-form-${sectionId}`)) ||
      sectionRoot.querySelector('product-form form');
    if (!form) return;

    root.dataset.bound = 'true';

    const variantInput = form.querySelector('input.product-variant-id[name="id"]');
    const priceRoot =
      (sectionId && document.getElementById(`price-${sectionId}`)) ||
      sectionRoot.querySelector('[id^="price-"]');
    const submitText =
      (sectionId && document.querySelector(`#ProductSubmitButton-${sectionId} span`)) ||
      form.querySelector('[type="submit"] span');
    const note = root.querySelector('[data-lz-edition-note]');
    const options = Array.from(root.querySelectorAll('[data-lz-edition-option]'));
    const priceTemplates = {
      single: root.querySelector('template[data-lz-price-template="single"]'),
      bundle: root.querySelector('template[data-lz-price-template="bundle"]'),
    };

    const applyChoice = (option) => {
      const variantId = option.getAttribute('data-variant-id');
      const target = option.getAttribute('data-target');
      const template = priceTemplates[target];

      options.forEach((candidate) => {
        const active = candidate === option;
        candidate.classList.toggle('is-active', active);
        candidate.setAttribute('aria-checked', active ? 'true' : 'false');
      });

      if (variantInput && variantId) {
        variantInput.disabled = false;
        variantInput.value = variantId;
      }

      if (priceRoot && template) {
        priceRoot.innerHTML = template.innerHTML;
      }

      if (submitText) {
        submitText.textContent = option.getAttribute('data-button-label') || 'Add to cart';
      }

      if (note) {
        note.textContent = option.getAttribute('data-note') || '';
      }
    };

    options.forEach((option) => {
      option.addEventListener('click', () => applyChoice(option));
    });

    const defaultOption =
      options.find((option) => option.getAttribute('data-variant-id') === (variantInput && variantInput.value)) ||
      options.find((option) => option.getAttribute('data-target') === 'single') ||
      options[0];

    if (defaultOption) {
      applyChoice(defaultOption);
    }
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initLittleZeEditionSelectors(document), { once: true });
} else {
  initLittleZeEditionSelectors(document);
}

document.addEventListener('shopify:section:load', (event) => {
  initLittleZeEditionSelectors(event.target);
});
